'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'megaphone';
var width = 512;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = ['M32 224.2l0 63.5 448 126 0-315.5-448 126z', 'M496 32c-8.8 0-16 7.2-16 16l0 17-448 126 0-15c0-8.8-7.2-16-16-16S0 167.2 0 176L0 336c0 8.8 7.2 16 16 16s16-7.2 16-16l0-15 102.3 28.8c-4.1 10.6-6.3 22.2-6.3 34.2 0 53 43 96 96 96 47 0 86.2-33.8 94.4-78.5L480 447 480 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16zM480 413.8l-448-126 0-63.5 448-126 0 315.5zM287.4 392.8c-4.3 31.2-31 55.2-63.4 55.2-35.3 0-64-28.7-64-64 0-9.1 1.9-17.7 5.3-25.5l122.1 34.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMegaphone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;